module.exports = __webpack_public_path__ + "static/media/mars8.474640cc.jpg";